import React, {Component} from 'react'
import {
    Form,
    FormGroup,
    FormFeedback,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Input,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Label
} from 'reactstrap'
import PropTypes from 'prop-types'
import moment from 'moment'
import Select from 'react-select'
import {Typeahead} from 'react-bootstrap-typeahead'
import {Query} from 'react-apollo'
import Joi from '@hapi/joi'

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import AUSelectGenerator from "../auto_updaters/Select";

import Loading from "../Loading";
import Search from "../timesheet/Search";
import projectExpenseQuery from '../../../queries/server/project_expense_types'
import projectsQuery from '../../../queries/server/search_projects'

const AUSelectUsers = AUSelectGenerator('filter_users', 'user_id first_name last_name', 'user_id', ['first_name', 'last_name'], [{
    key: 'active',
    value: 1
}])

const schema = Joi.object({
    user_id: Joi.required(),
    project_id: Joi.required(),
})


export default class ProjectExpenseInput extends Component {

    constructor(props) {
        super(props)

        this.state = {...props, expense_at: null, paid_at: null, validation: {}}

        if (!this.state.hasOwnProperty('user_id')) {

            const user = JSON.parse(sessionStorage.getItem('user'))

            this.state = {...this.state, user_id: user.user.user_id}
        }

        if (props.hasOwnProperty('expense_at') && props.expense_at) {

            this.state = {...this.state, expense_at: moment(props.expense_at).format('YYYY-MM-DD')}
        }
        else{
            this.state = {...this.state, expense_at: moment().format('YYYY-MM-DD')}
        }


        if (props.hasOwnProperty('paid_at') && props.paid_at) {

            this.state = {...this.state, paid_at: moment(props.paid_at).format('YYYY-MM-DD')}
        }


    }

    reset = () => {
        this.setState({
            id: null,
            expense_at: null,
            paid_at: null,
            destination: '',
            description: '',
            expense_type: '',
            vat: '',
            net: '',
            gross: '',
            file: null,
            project_id: null,

            project_search_query: '',
            validation: {}
        })
    }

    validateField = (field, value) => {

        console.log(field, value)

        const {validation} = this.state
        if(!value){
            console.log('validation', {validation: {...validation, [field]: 'Required'}})
            this.setState({validation: {...validation, [field]: 'Required'}})
        }
        else{
            const newValidation = validation
            delete newValidation[field]
            this.setState({validation: {...newValidation}})
        }
    }

    render() {

        /*<AUSelectExpenseType
                            required
                            name="Expense Type"
                            bsSize="sm"
                            label="Expense Type*"
                            value={expense_type}
                            onChange={(expense_type) => {
                                this.setState({expense_type})
                            }}

                        /> 
                        
                        <AUSelectProject
                            required
                            name="project_id"
                            bsSize="sm"
                            label="Project *"
                            value={project_id}
                            onChange={(project_id) => {
                                this.setState({project_id})
                            }}
                        />*/

        const {isOpen, toggle, onSave, saving, label} = this.props

        const {
            id,
            user_id,
            expense_at,
            destination,
            description,
            expense_type,
            net,
            vat,
            gross,
            paid_at,

            project,
            validation
        } = this.state

        return (
            <Modal isOpen={isOpen} toggle={() => {
                if (toggle) toggle()

                this.reset()
            }}>
                <Form
                    encType="multipart/form-data"
                    onSubmit={(e) => {

                        e.preventDefault()

                        if(Object.keys(validation).length === 0){
                            if (onSave) onSave({
                                ...this.state,
                                project_id: (project && project.hasOwnProperty('project_id')) ? project.project_id : null,
                                expense_type: expense_type.id
                            })
                        }
                        
                    }}
                >
                    <ModalHeader>{label}</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label for="user_id">User *</Label>
                            <AUSelectUsers
                                id="user_id"
                                bsSize="sm"
                                value={user_id}
                                invalid={validation.user_id}
                                onChange={(user_id) => {
                                    this.setState({user_id})
                                    this.validateField('user_id', user_id)
                                }}
                                onBlur={() => this.validateField('user_id', user_id)}
                            
                            />
                            <FormFeedback>{validation.hasOwnProperty('user_id') && validation.user_id}</FormFeedback>
                        </FormGroup>
                        
                        <FormGroup>
                            <Label for="projects">Project</Label>
                            <Query query={projectsQuery}>
                                {({data: {filter_projects}, loading}) => {
                                    return (
                                    <Typeahead
                                        id="projects"
                                        name="projects"
                                        required
                                        bsSize="sm"
                                        clearButton
                                        placeholder="Search Project"
                                        options={loading ? [] : filter_projects}
                                        isLoading={loading}
                                        labelKey={(option) => `${option.project_id}: ${option.name}`}
                                        selected={project ? [project] : []}
                                        onChange={(selected) => {
                                            const project = selected[0]
                                            this.setState({project})
                                            //this.validateField('project_id', project)
                                        }}
                                        onBlur={() => {
                                            //this.validateField('project_id', project)
                                        }}
                                    />)
                                }}
                            </Query>
                            {validation.hasOwnProperty('project_id') && <FormFeedback style={{display: 'block'}} invalid>{validation.project_id}</FormFeedback>}
                        </FormGroup>
                        

                        <FormGroup>
                            <Label for="expense_date">Expense Date *</Label>
                            <Input
                                id="expense_date"
                                bsSize="sm"
                                type="date"
                                value={expense_at}
                                invalid={validation.expense_at}
                                onChange={(evt) => {
                                    this.setState({expense_at: (!evt.target.value) ? null : evt.target.value})
                                    this.validateField('expense_at', evt.target.value)
                                }}
                                onBlur={() => this.validateField('expense_at', expense_at)}
                            />
                            <FormFeedback>{validation.hasOwnProperty('expense_at') && validation.expense_at}</FormFeedback>
                        </FormGroup>
                        
                        <FormGroup>
                            <Label for="paid_date">Paid Date</Label>
                            <Input
                                id="paid_date"
                                bsSize="sm"
                                type="date"
                                value={paid_at}
                                onChange={(evt) => {
                                    this.setState({paid_at: (!evt.target.value) ? null : evt.target.value})
                                }}
                            />
                        </FormGroup>
                        

                        <FormGroup>
                            <Label for="destination">Destination</Label>
                            <Input
                                id="destination"
                                bsSize="sm"
                                type="text"
                                value={destination}
                                onChange={(evt) => {
                                    this.setState({destination: evt.target.value})
                                }}

                            />
                        </FormGroup>

                        <FormGroup>
                            <Label for="description">Description</Label>
                            <Input
                                id="description"
                                bsSize="sm"
                                type="textarea"
                                value={description}
                                onChange={(evt) => {
                                    this.setState({description: evt.target.value})
                                }}

                            />
                        </FormGroup>

                        <FormGroup>
                            <Label for="projects">Expense Type *</Label>
                            <Query query={projectExpenseQuery}>
                                {({data: {project_expense_types}, loading}) => (
                                    <Typeahead
                                        name="project_expense_type"
                                        bsSize="sm"
                                        require
                                        clearButton
                                        placeholder="Select Expense Type"
                                        options={loading ? [] : project_expense_types}
                                        isLoading={loading}
                                        isInvalid={validation.expense_type}
                                        labelKey={(option) => `${option.description}: VAT(${option.vat_percentage}%)`}
                                        selected={expense_type ? [expense_type] : []}
                                        onChange={(selected) => {

                                            const expense_type = selected[0]
                                            this.setState({expense_type})
                                            this.validateField('expense_type', expense_type)

                                            if(expense_type && gross){
                                                const vat = ((gross / (100 + expense_type.vat_percentage)) * expense_type.vat_percentage).toFixed(2)
                                                this.setState({vat})
                                                this.validateField('gross', gross)
                                                this.validateField('vat', vat)
                                            }

                                            
                                        }}
                                        onBlur={() => this.validateField('expense_type', expense_type)}
                                    />
                                )}
                            </Query>
                            {validation.hasOwnProperty('expense_type') && <FormFeedback style={{display: 'block'}} invalid>{validation.expense_type}</FormFeedback>}
                        </FormGroup>

                        {expense_type && <div>
                            <FormGroup>
                                <Label for="gross">Total + VAT *</Label>
                                <InputGroup size="sm">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>£</InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        id="gross"
                                        bsSize="sm"
                                        type="number"
                                        value={gross}
                                        invalid={validation.gross}
                                        onChange={(evt) => {
                                            const gross = evt.target.value
                                            const vat = ((gross / (100 + expense_type.vat_percentage)) * expense_type.vat_percentage).toFixed(2)
                                            this.setState({gross, vat})

                                            this.validateField('gross', gross)

                                        }}
                                        onBlur={() => {
                                            this.validateField('gross', gross)

                                        }}

                                    />
                                    <FormFeedback>{validation.hasOwnProperty('gross') && validation.gross}</FormFeedback>
                                </InputGroup>
                            </FormGroup>
                            <FormGroup>
                                <Label for="vat">VAT *</Label>
                                <InputGroup size="sm">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>£</InputGroupText>
                                    </InputGroupAddon>
                                    <Input
                                        name="vat"
                                        bsSize="sm"
                                        type="number"
                                        value={vat}
                                        invalid={validation.vat}
                                        onChange={(evt) => {
                                            const vat = evt.target.value
                                            this.setState({vat})
                                            this.validateField('vat', vat)
                                        }}
                                        onBlur={() => {
                                            this.validateField('vat', vat)
                                        }}

                                    />
                                    <FormFeedback>{validation.hasOwnProperty('vat') && validation.vat}</FormFeedback>
                                </InputGroup>
                            </FormGroup>
                        </div>}
                        
                        <FormGroup>
                            <Label for="file">Upload Receipt</Label>
                            <Input
                                bsSize="sm"
                                type="file"
                                id="file"
                                onChange={(evt) => {
                                    this.setState({file: evt.target.files[0]})
                                }}
                            />
                        </FormGroup>

                    </ModalBody>
                    <ModalFooter>
                        <Button
                            size="sm"
                            color="success"
                            disabled={saving}
                            type="submit"
                        >
                            <FontAwesomeIcon
                                color="#fff"
                                icon="save"/>{' '}
                            {saving ? 'Saving...' : 'Save'}
                        </Button>
                    </ModalFooter>
                </Form>
            </Modal>
        )

    }

}